/**
 * Static placeholder data for the MainLayout demo shell.
 * Swap each export for a store/composable call once the layout is wired to real endpoints —
 * shapes here intentionally mirror what those endpoints already return elsewhere in the app.
 */

export const sidebarMenu = [
  { key: "home", label: "Home", icon: "HomeIcon", route: "home" },
  { key: "reminders", label: "Reminders", icon: "BellIcon", route: "reminders" },
  { key: "events", label: "Events", icon: "CalendarIcon", route: "events" },
  { key: "newsFeed", label: "Announcements", icon: "SpeakerphoneIcon", route: "Announcement Home Page" },
  { key: "groups", label: "Groups", icon: "UsersIcon", route: "groups" },
  { key: "mynotes", label: "My Comments", icon: "ChatAltIcon", route: "mynotes" },
  { key: "filemanager", label: "Resource Manager", icon: "FolderIcon", route: "filemanager" },
  { key: "active-role-plays", label: "Active Role Plays", icon: "VideoCameraIcon", route: 'active-role-plays' },
];

// Mirrors src/components/layout/header/AdminPortalMenus.vue's `routes` list and role gates.
export const adminPortalMenu = {
  key: "admin-portal",
  label: "Admin Portal",
  icon: "CogIcon",
  children: [
    { key: "manage-users", label: "Manage Users", path: "/central/manage-users", urlType: "central" },
    { key: "manage-curriculums", label: "Manage Curriculums", path: "/manage/curriculums", urlType: "lms" },
    { key: "manage-courses", label: "Manage Courses", path: "/manage/courses", urlType: "lms" },
    { key: "manage-categories", label: "Manage Categories", path: "/manage/categories", urlType: "lms" },
    { key: "manage-playlist", label: "Manage Playlist", path: "/manage/playlist", urlType: "lms" },
    { key: "manage-assignments", label: "Manage Assignments", path: "/manage/assignments", urlType: "lms" },
    { key: "manage-companies", label: "Manage Companies", path: "/central/companies", urlType: "central" },
    { key: "manage-stores", label: "Manage Stores", path: "/central/stores", urlType: "central" },
    { key: "usage-report", label: "Usage Analytics", path: "/usage-report", urlType: "lms" },
  ],
};


export const statCards = [
  { key: "completed", label: "Courses Completed", value: 12, accent: "emerald" },
  { key: "certificates", label: "Certificates Earned", value: 8, accent: "amber" },
  { key: "in-progress", label: "Courses in Progress", value: 24, accent: "sky" },
  { key: "assigned", label: "Assigned to You", value: 6, accent: "rose" },
];

export const bannerCategories = [
  "Showroom Floor Sales Process",
  "Phone",
  "Internet",
  "BDC",
  "Management",
];

export const courseTabs = [
  { key: "all", label: "All Courses" },
  { key: "learning-path", label: "My Learning Path & Playlists" },
  { key: "videos", label: "My Videos" },
  { key: "assigned", label: "Assigned Courses" },
  { key: "mystery-shop", label: "Mystery Shop Assignments", badge: 2 },
];

export const coursesByTab = {
  all: [
    { id: 1, title: "Steps to the Sales Process", category: "Showroom", progress: 15 },
    { id: 2, title: "Goal Setting", category: "Management", progress: 0 },
    { id: 3, title: "Objections", category: "Phone", progress: 70 },
    { id: 4, title: "Unsold Showroom Follow-Up", category: "BDC", progress: 40 },
    { id: 5, title: "Internet Lead Response Time", category: "Internet", progress: 100 },
    { id: 6, title: "Long-Term Follow-Up", category: "BDC", progress: 55 },
  ],
  "learning-path": [
    { id: 7, title: "New Hire Onboarding Path", category: "Management", progress: 30 },
    { id: 8, title: "Phone Skills Playlist", category: "Phone", progress: 60 },
  ],
  videos: [
    { id: 9, title: "Walkaround Demo Recording", category: "Showroom", progress: 100 },
    { id: 10, title: "My Role Play Submission", category: "BDC", progress: 100 },
  ],
  assigned: [
    { id: 4, title: "Unsold Showroom Follow-Up", category: "BDC", progress: 40 },
    { id: 11, title: "Long-Term Follow-Up", category: "BDC", progress: 20 },
    { id: 12, title: "Objections", category: "Phone", progress: 70 },
  ],
  "mystery-shop": [
    { id: 13, title: "August Mystery Shop — Internet", category: "Internet", progress: 0 },
    { id: 14, title: "August Mystery Shop — Phone", category: "Phone", progress: 0 },
  ],
};

export const reminders = [
  {
    id: 1,
    severity: "overdue",
    title: "Assignment Overdue",
    description: 'Your assigned course, "Unsold Showroom" is overdue.',
    date: "Thu, Jul 30, 2026 12:00 PM",
    actionLabel: "Complete Course",
  },
  {
    id: 2,
    severity: "due-soon",
    title: "Assignment Due Soon",
    description: 'Your assigned course, "Long-Term Follow-Up" is due soon.',
    date: "Fri, Aug 3, 2026 11:05 PM",
    actionLabel: "Continue Course",
  },
  {
    id: 3,
    severity: "due-soon",
    title: "Assignment Due Soon",
    description: 'Your assigned course, "Objections" is due soon.',
    date: "Sat, Aug 8, 2026 11:05 PM",
    actionLabel: "Continue Course",
  },
];

export const events = [
  {
    id: 1,
    title: "Regional Sales Call",
    description: "Monthly sync with regional managers.",
    date: "Mon, Aug 10, 2026 9:00 AM",
  },
  {
    id: 2,
    title: "New Hire Orientation",
    description: "Onboarding session for the August cohort.",
    date: "Wed, Aug 12, 2026 1:00 PM",
  },
];

export const currentUser = {
  initials: "BSM",
  name: "BSM ADMIN",
  role: "Admin",
};
